import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import { Helmet } from "react-helmet-async";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_crm-news-hub/artifacts/srv2lps9_ChatGPT%20Image%20Apr%202%2C%202026%2C%2010_47_10%20AM.png";

const OfferResponsePage = () => {
  const { token, action } = useParams();
  const [status, setStatus] = useState("loading");
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const respond = async () => {
      try {
        const res = await axios.get(`${API}/offers/respond/${token}/${action}`);
        setData(res.data);
        setStatus("done");
      } catch (e) {
        setError(e.response?.data?.detail || "This offer link is no longer valid.");
        setStatus("error");
      }
    };
    if (token && action) respond();
  }, [token, action]);

  return (
    <div className="min-h-screen bg-[#0C2E3C] flex items-center justify-center px-4" data-testid="offer-response-page">
      <Helmet>
        <title>Roster Offer | Commonwealth FC</title>
      </Helmet>
      <div className="max-w-md w-full text-center">
        <img src={LOGO_URL} alt="Commonwealth FC" className="h-20 w-auto mx-auto mb-8" />

        {status === "loading" && (
          <div data-testid="offer-loading">
            <Loader2 size={48} className="mx-auto text-[#C8E64E] animate-spin mb-4" />
            <p className="text-[#F0F4F3]/70 text-lg">Processing your response...</p>
          </div>
        )}

        {status === "done" && data?.status === "accepted" && (
          <div data-testid="offer-accepted">
            <CheckCircle2 size={64} className="mx-auto text-[#C8E64E] mb-6" />
            <h1 className="font-heading text-4xl font-bold text-[#F0F4F3] mb-4">Welcome to the Team!</h1>
            <p className="text-[#F0F4F3]/70 text-lg mb-2">
              Congratulations <span className="text-[#C8E64E] font-bold">{data.player_name}</span>!
            </p>
            <p className="text-[#F0F4F3]/60 mb-8">
              You{"'"}ve accepted your roster spot on <span className="font-bold text-[#F0F4F3]">{data.team_name}</span>.
            </p>
            <p className="text-[#F0F4F3]/50 text-sm">
              A coach or team manager will be in touch with next steps. We{"'"}re excited to have you!
            </p>
          </div>
        )}

        {status === "done" && data?.status === "declined" && (
          <div data-testid="offer-declined">
            <XCircle size={64} className="mx-auto text-[#F0F4F3]/40 mb-6" />
            <h1 className="font-heading text-3xl font-bold text-[#F0F4F3] mb-4">Offer Declined</h1>
            <p className="text-[#F0F4F3]/70 text-lg mb-2">
              <span className="text-[#C8E64E]">{data.player_name}</span>, we understand.
            </p>
            <p className="text-[#F0F4F3]/60 mb-8">
              Your spot on {data.team_name} has been released. If you change your mind, please contact us.
            </p>
          </div>
        )}

        {status === "error" && (
          <div data-testid="offer-error">
            <XCircle size={64} className="mx-auto text-red-400 mb-6" />
            <h1 className="font-heading text-3xl font-bold text-[#F0F4F3] mb-4">Link Expired</h1>
            <p className="text-[#F0F4F3]/60">{error}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default OfferResponsePage;
